export function LoadingLayout() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px]">
      <div className="relative">
        {/* Outer spinner ring */}
        <div className="w-12 h-12 rounded-full border-4 border-gray-200"></div>
        {/* Inner animated spinner */}
        <div className="w-12 h-12 absolute top-0 left-0 rounded-full border-4 border-blue border-t-transparent animate-spin"></div>
      </div>
      <p className="mt-4 text-sm font-medium text-gray-600 dark:text-gray-300 animate-pulse">
        Loading...
      </p>
    </div>
  );
}